import { AlertCircle } from 'lucide-react';

export default function ConfirmDialog({ 
  title = '¿Estás seguro?',
  message, 
  onConfirm, 
  onCancel,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning'
}) {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`p-3 rounded-full ${
              type === 'danger' ? 'bg-red-100' :
              type === 'warning' ? 'bg-yellow-100' :
              'bg-blue-100'
            }`}>
              <AlertCircle className={`w-6 h-6 ${
                type === 'danger' ? 'text-red-600' :
                type === 'warning' ? 'text-yellow-600' :
                'text-blue-600'
              }`} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold mb-2" style={{ color: '#051C2C' }}>
                {title}
              </h3>
              <p className="text-gray-600">
                {message}
              </p>
            </div>
          </div>
        </div>
        
        <div className="px-6 pb-6 flex gap-3">
          <button
            onClick={handleCancel}
            className="flex-1 px-4 py-3 border-2 border-gray-300 rounded-xl font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`flex-1 px-4 py-3 rounded-xl font-medium text-white transition-all transform hover:scale-105 ${
              type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
              type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
              'bg-blue-600 hover:bg-blue-700'
            }`}
            style={type === 'primary' ? { backgroundColor: '#003594' } : {}}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
